import NotFoundPageComponent from '../components/not-found';

import RPTRADE from './components/RPTRADE';
import ONE from './components/ONE';
import REPORTS from './components/REPORTS';
import AVG from './components/AVG';
import TICKETS from './components/TICKETS';
import common from './components/common';
import VIEW from './components/VIEW';
import GMVA from './components/GMVA';

const routes = [
  ...common,
  ...RPTRADE,
  ...ONE,
  ...REPORTS,
  ...AVG,
  ...TICKETS,
  ...VIEW,
  ...GMVA,
  {
    path: '*',
    redirect: '/404',
    requiresAuth: false,
  },
  {
    path: '/404',
    name: 'not-found',
    meta: {
      title: 'not_found',
      showHeader: false,
      requiresAuth: false,
    },
    component: NotFoundPageComponent,
  },
];

export default routes;
